var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import styles from './PickerHeader.module.scss';
import PropTypes from 'prop-types';
import { subDays, format, isSameDay, subYears, subMonths, startOfMonth, endOfMonth, differenceInDays } from 'date-fns';
import { Switch } from '../../../Switch/Switch';
import { Dropdown } from '../../../Dropdown/Dropdown';
var PickerHeader = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, startCompareDate = _a.startCompareDate, endCompareDate = _a.endCompareDate, customRange = _a.customRange, compareable = _a.compareable, compareOn = _a.compareOn, onCompareChange = _a.onCompareChange, onChange = _a.onChange;
    var setPrecedingPeriod = function () {
        var start = subDays(startDate, differenceInDays(endDate, startDate) + 1);
        var end = subDays(startDate, 1);
        return { start: start, end: end };
    };
    var setSamePeriod = function () {
        var start = subYears(startDate, 1);
        var end = subYears(endDate, 1);
        return { start: start, end: end };
    };
    var setPrecedingYear = function () {
        var start = subYears(startDate, 1);
        var end = subYears(endDate, 1);
        return { start: start, end: end };
    };
    var setPrecedingMonth = function () {
        var start = startOfMonth(subMonths(startDate, 1));
        var end = endOfMonth(subMonths(endDate, 1));
        return { start: start, end: end };
    };
    var getPrecedingSetter = function () {
        if (customRange === 'Previous Year')
            return setPrecedingYear();
        if (customRange === 'Previous Month')
            return setPrecedingMonth();
        return setPrecedingPeriod();
    };
    var customRanges = [
        {
            label: 'Preceding Period',
            value: 'preceding',
            setter: function () { return getPrecedingSetter(); },
        },
        {
            label: 'Same Period Last Year',
            value: 'same_last_year',
            setter: function () { return setSamePeriod(); },
        },
        {
            label: 'Custom Period',
            value: 'custom',
            setter: function () { return ({ start: startDate, end: endDate }); },
        },
    ];
    var _b = useState(customRanges[2]), customCompare = _b[0], setCustomCompare = _b[1];
    useEffect(function () {
        setCustomCompare(customRanges[2]);
    }, [compareOn]);
    var onCustomCompareChange = function (active) {
        var _a = active.setter(), start = _a.start, end = _a.end;
        setCustomCompare(active);
        onChange(start, start, end, compareOn ? customRange : '');
    };
    var renderDate = function (date) {
        return _jsx("span", __assign({ className: styles.Date }, { children: format(date, 'd MMM yyyy') }));
    };
    var renderPrimarySelection = function () { return (_jsxs("section", __assign({ className: styles.PrimarySelection }, { children: [_jsx("span", __assign({ className: styles.CustomRange }, { children: customRange || 'Custom' })), renderDate(startDate), !isSameDay(startDate, endDate) && _jsxs("span", __assign({ className: styles.EndDate }, { children: ["- ", renderDate(endDate)] }))] }))); };
    var renderCompareSelection = function () { return (_jsxs("section", __assign({ className: styles.CompareSelection }, { children: [_jsx("span", __assign({ className: styles.ComparingWith }, { children: "Comparing with" })), _jsx(Dropdown, { small: true, smallText: true, noMargin: true, showSelected: true, label: '', right: true, selected: customCompare, options: customRanges, dataId: 'custom-compare', className: styles.CustomCompare, onChange: onCustomCompareChange }), renderDate(startCompareDate), !isSameDay(startCompareDate, endCompareDate) && (_jsxs("span", __assign({ className: styles.EndDate }, { children: ["- ", renderDate(endCompareDate)] })))] }))); };
    return (_jsxs("section", __assign({ className: styles.PickerHeader }, { children: [_jsxs("section", { children: [renderPrimarySelection(), compareOn && renderCompareSelection()] }), compareable && _jsx(Switch, { label: 'Compare', labelLeft: true, checked: compareOn, onChange: onCompareChange })] })));
};
PickerHeader.propTypes = {
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
    startCompareDate: PropTypes.instanceOf(Date).isRequired,
    endCompareDate: PropTypes.instanceOf(Date).isRequired,
    customRange: PropTypes.string.isRequired,
    compareable: PropTypes.bool,
    compareOn: PropTypes.bool.isRequired,
    onCompareChange: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};
export { PickerHeader };
//# sourceMappingURL=PickerHeader.js.map